import { LandingSectionTitle } from '@features/landing/shared/ui/components/LandingSectionTitle';
import {
  LINK_SUMMER_TOURNAMENT_RULES_BLITZ,
  LINK_SUMMER_TOURNAMENT_RULES_RAPID,
  LINK_SUMMER_TOURNAMENTS,
} from '@features/chessrussian/customizations/constants';
import { LandingButton } from '@features/landing/shared/ui/components/LandingButton';
import { TournamentDetailsRow } from '@features/landing/shared/ui/components/TournamentDetailsRow';
import { LandingChip } from '@features/landing/shared/ui/components/LandingChip';
import { ClockControl } from '@features/landing/shared/ui/components/ClockControl';
import { RoundsCount } from '@features/landing/shared/ui/components/RoundsCount';
import { TournamentSystem } from '@features/landing/shared/ui/components/TournamentSystem';
import { NonMobileBr } from '@features/landing/shared/ui/components/Br/Br';
import { TournamentShortDto } from '@features/landing/grandprix/typings';
import { useMediaQuery } from '@providers/MediaQueryProvider';

type TournamentLike = Pick<
  TournamentShortDto,
  'clockControlSettings' | 'system' | 'swissSettings'
>;

export function SummerUpcomingTournaments() {

  const blitz: TournamentLike = {
    clockControlSettings: {
      initialSeconds: 180,
      addSecondsPerMove: 2,
    },
    system: 'Swiss',
    swissSettings: {
      roundsCount: 9,
    },
  };
  const rapid: TournamentLike = {
    clockControlSettings: {
      initialSeconds: 600,
      addSecondsPerMove: 5,
    },
    system: 'Swiss',
    swissSettings: {
      roundsCount: 7,
    },
  };

  const device = useMediaQuery();
  const chipSize =
    device === 'tablet' || device === 'mobile' ? 'large' : 'medium';

  return (
    <>
      <LandingSectionTitle>Ближайшие турниры серии</LandingSectionTitle>

      {blitz && (
        <TournamentDetailsRow
          title="Блиц"
          tags={
            <>
              <LandingChip size={chipSize}>
                <ClockControl tournament={blitz} />
              </LandingChip>
              <LandingChip size={chipSize}>
                <RoundsCount tournament={blitz} />
              </LandingChip>
              <LandingChip size={chipSize}>
                <TournamentSystem tournament={blitz} />
              </LandingChip>
            </>
          }
          date={
            <>
              каждый вторник &nbsp;
              <NonMobileBr />
              лета в 10:00 МСК
            </>
          }
          statement={
            <LandingButton href={LINK_SUMMER_TOURNAMENT_RULES_BLITZ}>
              Положение
              <br />о турнире&nbsp;›
            </LandingButton>
          }
          link={
            <LandingButton
              href={LINK_SUMMER_TOURNAMENTS}
              size="22m-40"
              color="active-faded"
            >
              Турниры&nbsp;›
            </LandingButton>
          }
        />
      )}

      {rapid && (
        <TournamentDetailsRow
          title="Рапид"
          tags={
            <>
              <LandingChip size={chipSize}>
                <ClockControl tournament={rapid} />
              </LandingChip>
              <LandingChip size={chipSize}>
                <RoundsCount tournament={rapid} />
              </LandingChip>
              <LandingChip size={chipSize}>
                <TournamentSystem tournament={rapid} />
              </LandingChip>
            </>
          }
          date={
            <>
              каждый четверг &nbsp;
              <NonMobileBr />
              лета в 10:00 МСК
            </>
          }
          statement={
            <LandingButton href={LINK_SUMMER_TOURNAMENT_RULES_RAPID}>
              Положение
              <br />о турнире&nbsp;›
            </LandingButton>
          }
          link={
            <LandingButton
              href={LINK_SUMMER_TOURNAMENTS}
              size="22m-40"
              color="active-faded"
            >
              Турниры&nbsp;›
            </LandingButton>
          }
        />
      )}
    </>
  );
}
